export default "__VITE_ASSET__Dy$tDH6l__"